import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SupplementalLoadsData, SupplementalLoadsService } from '../../services/supplemental-loads.service';

@Component({
  selector: 'supplemental-loads',
  templateUrl: './supplemental-loads.component.html',
  standalone: false
})
export class SupplementalLoadsComponent implements OnInit {
  @Input() unitSelect: number = 0;       // 0 = US Customary, 1 = SI
  @Input() fml: number = -1;             // Initial Fml value
  @Input() mml: number = -1;             // Initial Mml value
  @Input() imageUrl: string = '/assets/images/supplemental_loads.png';
  @Input() imageAlt: string = 'Supplemental Loads - Fy.ml and Mz.ml diagram';

  @Output() loadsChanged = new EventEmitter<SupplementalLoadsData>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previousStep = new EventEmitter<void>();

  constructor(private supplementalLoadsService: SupplementalLoadsService) {}

  ngOnInit(): void {
    // Sync initial values from inputs
    if (this.fml !== -1) {
      this.supplementalLoadsService.setFml(this.fml);
    }
    if (this.mml !== -1) {
      this.supplementalLoadsService.setMml(this.mml);
    }
  }

  get fmlUnit(): string {
    return this.unitSelect === 0 ? 'lb' : 'N';
  }

  get mmlUnit(): string {
    return this.unitSelect === 0 ? 'ft-lb' : 'kN-m';
  }

  get displayFml(): string | number {
    return this.supplementalLoadsService.fml !== -1 ? this.supplementalLoadsService.fml : '';
  }

  get displayMml(): string | number {
    return this.supplementalLoadsService.mml !== -1 ? this.supplementalLoadsService.mml : '';
  }

  onFmlChange(value: string): void {
    const num = parseFloat(value);
    if (!isNaN(num)) {
      this.supplementalLoadsService.setFml(num);
      this.emitLoadsChanged();
    }
  }

  onMmlChange(value: string): void {
    const num = parseFloat(value);
    if (!isNaN(num) && num >= 0) {
      this.supplementalLoadsService.setMml(num);
      this.emitLoadsChanged();
    }
  }

  onNext(): void {
    this.nextStep.emit();
  }

  onBack(): void {
    this.previousStep.emit();
  }

  private emitLoadsChanged(): void {
    this.loadsChanged.emit(this.supplementalLoadsService.getLoadsData());
  }
}
